import { requiredNumber } from '@/forms/schemas/definitions';
import { parseLocaleNumber } from '@/utils/parseLocaleNumber';

type VatIssue = { message: string; path: string[] };

export function validateVatAmountAgainstAmountIncludingVat(
  amountIncludingVat: string,
  vatAmount: string,
): VatIssue[] {
  if (!requiredNumber().safeParse(amountIncludingVat).success) return [];

  const parsedAmount = parseLocaleNumber(amountIncludingVat);
  const parsedVat = parseLocaleNumber(vatAmount);

  if (parsedVat === 0) return [];

  if (parsedAmount === 0) {
    return [
      {
        message:
          'validationErrors.VatAmountMustBeZeroWhenAmountIncludingVatIsZero',
        path: ['vatAmount'],
      },
    ];
  }

  if (Math.sign(parsedAmount) !== Math.sign(parsedVat)) {
    return [
      {
        message:
          'validationErrors.VatAmountMustHaveSameSignAsAmountIncludingVat',
        path: ['vatAmount'],
      },
    ];
  }

  if (Math.abs(parsedVat) >= Math.abs(parsedAmount)) {
    const message =
      Math.sign(parsedAmount) === 1
        ? 'validationErrors.VatAmountMustBeLessThanAmountIncludingVat'
        : 'validationErrors.VatAmountMustBeGreaterThanAmountIncludingVat';
    return [{ message, path: ['vatAmount'] }];
  }

  return [];
}
